import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[lm-drag-and-drop]',
  standalone: false
})
export class LMDragAndDropDirective {
  private elementRef: ElementRef;

  constructor(private _elementRef: ElementRef) {
    this.elementRef = this._elementRef;
  }

  @HostListener('dragover', [ '$event' ])
  public onDragOver(event: DragEvent) {
    this.addDragClass();

    // Stop browser from downloading file
    event?.stopPropagation();
    event?.preventDefault();
  }

  @HostListener('dragleave', [ '$event' ])
  public onDragLeave(event: DragEvent) {
    this.removeDragClass();
    event?.stopPropagation();
    event?.preventDefault();
  }

  @HostListener('drop', [ '$event' ])
  public onDrop(event: DragEvent) {
    if (event?.dataTransfer) {
      this.filesDropped.emit(event.dataTransfer);
    }

    this.removeDragClass();
    event?.stopPropagation();
    event?.preventDefault();
  }

  @Input() isAttachmentList = false;
  @Output() filesDropped = new EventEmitter<DataTransfer>();

  private addDragClass() {
    const nativeElement: HTMLElement = this?.elementRef?.nativeElement;

    if (nativeElement && this.isAttachmentList) {
      nativeElement.classList.add('lm-drag-over');
    }
  }

  private removeDragClass() {
    const nativeElement: HTMLElement = this?.elementRef?.nativeElement;

    if (nativeElement && this.isAttachmentList) {
      nativeElement.classList.remove('lm-drag-over');
    }
  }
}